import api from "../services/authService";

const appendMany = (params, key, values = []) => {
  values.filter(Boolean).forEach((value) => params.append(key, value));
};

export const fetchArticleBankEntries = async ({
  page = 1,
  pageSize = 25,
  query = "",
  conditions = [],
  elements = [],
  kinds = [],
  bodySystems = [],
  claimParts = [],
  exposures = [],
  events = [],
} = {}) => {
  const params = new URLSearchParams({
    page: String(page),
    page_size: String(pageSize),
  });
  if (query) params.set("q", query);
  appendMany(params, "condition", conditions);
  appendMany(params, "element", elements);
  appendMany(params, "kind", kinds);
  appendMany(params, "body_system", bodySystems);
  appendMany(params, "claim_part", claimParts);
  appendMany(params, "exposure", exposures);
  appendMany(params, "event", events);
  return api.get(`/article-bank/entries/?${params.toString()}`);
};

export const fetchArticleBankFacets = async () => api.get("/article-bank/facets/");

export const fetchArticleBankEntry = async (entryId) =>
  api.get(`/article-bank/entries/${entryId}/`);

// The article itself as a PDF (Office files converted by the server).
// Returns the axios response; `data` is a Blob.
export const fetchArticleBankPreview = async (entryId) =>
  api.get(`/article-bank/entries/${entryId}/preview/`, { responseType: "blob" });
